/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * BillingPortalSessionDtoBase
 * auto generated base class for the model BillingPortalSessionDtoModel.
 */
export const BillingPortalSessionDtoModelBase = ModelBase
  .named('BillingPortalSessionDto')
  .props({
    __typename: types.optional(types.literal("BillingPortalSessionDto"), "BillingPortalSessionDto"),
    url: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class BillingPortalSessionDtoModelSelector extends QueryBuilder {
  get url() { return this.__attr(`url`) }
}
export function selectFromBillingPortalSessionDto() {
  return new BillingPortalSessionDtoModelSelector()
}

export const billingPortalSessionDtoModelPrimitives = selectFromBillingPortalSessionDto().url
